import http from './axios';

export interface IndicatorSetDto {
  id?: number;
  indSetCategoryId?: number;
  indSetCode?: string;
  indSetDescription?: string;
  indSetLabel?: string;
  indSetName?: string;
  indSetSort?: number;
  status?: number;
}

export default class IndicatorSetServices {
  private readonly list_api = '/v1/indicatorset/list';
  private readonly info_api = '/v1/indicatorset/info';
  private readonly save_api = '/v1/indicatorset/save';
  private readonly update_api = '/v1/indicatorset/update';
  private readonly remove_api = '/v1/indicatorset/delete';

  constructor() {}

  async getList(params?: object): Promise<any> {
    let res: any = await http.get(this.list_api, { params: params });
    return res.payload;
  }

  async getInfo(id: string | number) {
    let res: any = await http.get(this.info_api + '/' + id);
    return res.payload;
  }

  async add(data: IndicatorSetDto) {
    const params = { ...data, indSetSort: '1', indSetCode: 'IND_SET_' + data.indSetCode };
    let res: any = await http.post(this.save_api, params);
    return res.header?.code == 200 ? res.payload : false;
  }

  async update(data: IndicatorSetDto): Promise<boolean> {
    let res: any = await http.post(this.update_api, data);
    return res.header?.code == 200;
  }

  async remove(id: string | number) {
    let res: any = await http.post(this.remove_api, [id]);
    return res.header?.code == 200;
  }
}
